const HTTP_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'] as const;

export type Href = {
	href: string;
	method: (typeof HTTP_METHODS)[number];
};

export const parseHref = (value: unknown): Href => {
	if (
		!value ||
		typeof value !== 'object' ||
		!('href' in value) ||
		typeof value.href !== 'string' ||
		!value.href.trim() ||
		!('method' in value)
	) {
		throw new Error('Invalid href: expected a non-empty href and supported method');
	}

	const method = HTTP_METHODS.find((method) => method === value.method);
	if (!method) throw new Error('Invalid href method');

	return { href: value.href, method };
};
